/* unplugin-vue-components disabled */import { render } from "./ShareBox.vue?vue&type=template&id=47692c1e&scoped=true"
import script from "./ShareBox.vue?vue&type=script&lang=js"
export * from "./ShareBox.vue?vue&type=script&lang=js"

import "./ShareBox.vue?vue&type=style&index=0&id=47692c1e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47692c1e"]])

export default __exports__